import React from 'react'
import './Work.css'
import Footer from '../Footer/Footer.js';
function Work() {
  return (
    <>
    <div className='work'>Work Page</div>
    <Footer/>
    </>
  )
}

export default Work